export const focusBoneErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('object has no attribute \'get_focus_bone\'') !== -1) {
			return {
				type: 'focusBoneErrorTest',
				color: 'IndianRed',
				title: 'Missing Focus Bone Error',
				text: 'Broken mod is missing necessary object data.',
				description: 'A broken modification adds new or edits existing objects while missing necessary "Focus Bone" data.<br/>' +
        'The mod creator is required to fix this error.<br/><br/>' +
        'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that could be causing this issue and remove it.<br/>' +
        'If this is a new issue, try removing the most recent mod you have installed.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>7817e6c835211c145ba05921</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-09-17 19:31:26</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.18.1020-1.200.000.364.Release</buildsignature>
        <categoryid>__init__.py:195</categoryid>
        <desyncid>7817e6c835211c145ba05921</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception while running interaction Interaction &lt;class 'sims4.tuning.instances.painting_View_Passive'&gt; on brittpinkiesimsdecocooler:0x019107f8e3ca5944; id:8803, sim: (AttributeError: 'brittpinkiesimsdecocooler' object has no attribute 'get_focus_bone')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 205, in c_api_server_tick
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone.py&quot;, line 464, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\time_service.py&quot;, line 112, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 212, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 376, in _run
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim.py&quot;, line 3444, in _process_interaction_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 684, in process_one_interaction_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 548, in _process_one_interaction_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 598, in run_interaction_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\mixer_interaction.py&quot;, line 746, in perform_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 5686, in perform_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 5667, in perform_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 5796, in _do_perform_trigger_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 5816, in _do_perform_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 5803, in _get_behavior
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\mixer_interaction.py&quot;, line 523, in build_basic_elements
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 6086, in build_basic_elements
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\tuning\tunable.py&quot;, line 523, in __call__
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\sim_focus.py&quot;, line 252, in factory
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\sim_focus.py&quot;, line 222, in with_sim_focus
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\sim_focus.py&quot;, line 194, in __init__
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\__init__.py&quot;, line 195, in __getattr__
AttributeError: 'brittpinkiesimsdecocooler' object has no attribute 'get_focus_bone'
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/focusBoneErrorTest.js